import { HOUR_IN_MILLISECONDS } from 'config';
import { useScenario } from 'modules/project/providers/scenario';
import {
  MineModelDto,
  PourDto,
  ProjectDto,
  RheologyDataDto,
  useMineModelQuery,
  useMineModelRheologyDataListQuery,
  usePoursQuery,
  useProjectQuery
} from 'providers/api';
import { UseQueryResult } from 'react-query';
import { StopeNotePageParams } from './constants';

export type StopeNoteQueries = [
  UseQueryResult<ProjectDto>,
  UseQueryResult<MineModelDto | undefined>,
  UseQueryResult<PourDto[]>,
  UseQueryResult<RheologyDataDto[]>,
];

const useStopeNoteQueries = (params: StopeNotePageParams): StopeNoteQueries => {
  const { activeScenarioId } = useScenario();

  return [
    useProjectQuery(params.projectId, {
      staleTime: HOUR_IN_MILLISECONDS,
    }),
    useMineModelQuery({ mineModelId: params.projectId }, {
      staleTime: HOUR_IN_MILLISECONDS,
    }),
    usePoursQuery(
      {
        projectId: params.projectId,
        stopeId: params.stopeId,
        scenarioId: activeScenarioId ?? undefined,
        includeRockFill: true,
      },
      { staleTime: HOUR_IN_MILLISECONDS },
    ),
    useMineModelRheologyDataListQuery(
      { mineModelId: params.projectId, rheologyDataSetIds: [] },
      { staleTime: HOUR_IN_MILLISECONDS },
    ),
  ];
};

export default useStopeNoteQueries;
